export interface StatusModel {
  // svg: string;
  textColor: string;
  bgColor: string;
}

class TransactionStatusClass {
  private statusMap = new Map<string, StatusModel>([
    [
      "pending",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "pending_review",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "completed",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "enabled",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "needs_review",
      {
        textColor: "#7C3AED",
        bgColor: "bg-[#E2D4FF]",
      },
    ],
    [
      "yes",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "approved",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "paid",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "paid_over",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "over payment",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "under payment",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "processing",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "confirmation",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "waiting",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "initiated",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "failed",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "incomplete",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "declined",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "retry",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "disabled",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "no",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "cancelled",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "system error",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "refund processing",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "refund failed",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "refund success",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "compliance",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "expired",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "insufficient balance",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "merchant payin",
      {
        textColor: "#1D4ED8",
        bgColor: "bg-[#C7DBFF]",
      },
    ],
    [
      "merchant payout",
      {
        textColor: "#7C3AED",
        bgColor: "bg-[#E2D4FF]",
      },
    ],
    [
      "personal payin",
      {
        textColor: "#0F766E",
        bgColor: "bg-[#BDEFEA]",
      },
    ],
    [
      "personal payout",
      {
        textColor: "#BE185D",
        bgColor: "bg-[#FBCFE8]",
      },
    ],
    [
      "merchant",
      {
        textColor: "#7C3AED",
        bgColor: "bg-[#E2D4FF]",
      },
    ],
    [
      "personal",
      {
        textColor: "#0F766E",
        bgColor: "bg-[#BDEFEA]",
      },
    ],
    [
      "individual",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "affiliate",
      {
        textColor: "#BE185D",
        bgColor: "bg-[#FBCFE8]",
      },
    ],
    [
      "cashier",
      {
        textColor: "#1D4ED8",
        bgColor: "bg-[#C7DBFF]",
      },
    ],
    [
      "institutional",
      {
        textColor: "#A16207",
        bgColor: "bg-[#FEF9C3]",
      },
    ],
    [
      "small_merchant",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "settlement",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "pay-in",
      {
        textColor: "#0F766E",
        bgColor: "bg-[#BDEFEA]",
      },
    ],
    [
      "pay-out",
      {
        textColor: "#7C3AED",
        bgColor: "bg-[#E2D4FF]",
      },
    ],
    [
      "active",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "suspended",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "frozen",
      {
        textColor: "#1D4ED8",
        bgColor: "bg-[#C7DBFF]",
      },
    ],
    [
      "inactive",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "revoked",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "processed",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "editor",
      {
        textColor: "#1D4ED8",
        bgColor: "bg-[#C7DBFF]",
      },
    ],
    [
      "owner",
      {
        textColor: "#7C3AED",
        bgColor: "bg-[#E2D4FF]",
      },
    ],
    [
      "viewer",
      {
        textColor: "#686E92",
        bgColor: "bg-[#F1F3F5]",
      },
    ],
    [
      "deactivated",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "deleted",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "paused",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "confirmed",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "created",
      {
        textColor: "#686E92",
        bgColor: "bg-[#F1F3F5]",
      },
    ],
    [
      "submitted",
      {
        textColor: "#686E92",
        bgColor: "bg-[#F1F3F5]",
      },
    ],
    [
      "fulfilled",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "partial payment",
      {
        textColor: "#FE961C",
        bgColor: "bg-[#FFF0E4]",
      },
    ],
    [
      "success",
      {
        textColor: "#66AD7B",
        bgColor: "bg-[#E2F6E8]",
      },
    ],
    [
      "disputed",
      {
        textColor: "#D61C1C",
        bgColor: "bg-[#FFE8E8]",
      },
    ],
    [
      "draft",
      {
        textColor: "#686E92",
        bgColor: "bg-[#F1F3F5]",
      },
    ],
  ]);

  public getTransactionStatusIcon(transactionStatus: string): StatusModel {
    const status = transactionStatus.toLowerCase();
    return (
      this.statusMap.get(status) || {
        textColor: "icon-base",
        bgColor: "bg-icon-white",
      }
    );
  }

  public getTransactionIconColor(transactionStatus: string): string {
    const status = this.getTransactionStatusIcon(transactionStatus);
    return status.textColor;
  }

  public getTransactionBgColor(transactionStatus: string): string {
    const status = this.getTransactionStatusIcon(transactionStatus);
    return status.bgColor;
  }
  public getTransactionHeader(transactionStatus: string): string {
    const status = transactionStatus.toLowerCase();
    if (
      status === "completed" ||
      status === "over payment" ||
      status === "refund success" ||
      status === "compliance" ||
      status === "under payment" ||
      status === "paid_over"
    ) {
      return "Transaction Completed";
    } else if (
      status === "pending" ||
      status === "processing" ||
      status === "confirmation" ||
      status === "waiting" ||
      status === "initiated" ||
      status === "insufficient balance"
    ) {
      return "Transaction in Progress";
    } else if (
      status === "failed" ||
      status === "cancelled" ||
      status === "system error" ||
      status === "refund failed"
    ) {
      return "Transaction Failed!";
    } else if (status === "expired") {
      return "Transaction Expired!";
    }
    return "";
  }
}

export default TransactionStatusClass;
